import { render, staticRenderFns } from "./pendingVillage.vue?vue&type=template&id=72939f08"
import script from "./pendingVillage.vue?vue&type=script&lang=js"
export * from "./pendingVillage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports